import { useState, useEffect, useCallback } from 'react';
import { getAdminCharacters } from '../../api/admin';
import s from './AdminPages.module.css';

export default function AdminCharacters() {
  const [data, setData] = useState({ characters: [], pagination: {} });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [hskLevel, setHskLevel] = useState('');

  const fetchChars = useCallback(() => {
    setLoading(true);
    getAdminCharacters({ page, search, hsk_level: hskLevel })
      .then(setData)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [page, search, hskLevel]);

  useEffect(() => { void (async () => { await fetchChars(); })(); }, [fetchChars]);

  function handleSearch(e) {
    e.preventDefault();
    setPage(1);
    fetchChars();
  }

  const { pagination } = data;

  return (
    <div>
      <h1 className={s.title}>Characters</h1>

      <div className={s.filterRow}>
        <form onSubmit={handleSearch} className={s.searchRow}>
          <input
            type="text"
            placeholder="Search character, pinyin, or definition..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className={s.searchInput}
          />
          <button type="submit" className={s.searchBtn}>Search</button>
        </form>
        <select
          value={hskLevel}
          onChange={(e) => { setHskLevel(e.target.value); setPage(1); }}
          className={s.select}
        >
          <option value="">All HSK Levels</option>
          <option value="1">HSK 1</option>
          <option value="2">HSK 2</option>
          <option value="3">HSK 3</option>
          <option value="4">HSK 4</option>
          <option value="5">HSK 5</option>
          <option value="6">HSK 6</option>
        </select>
      </div>

      <div className={s.tableWrap}>
        <table className={s.table}>
          <thead>
            <tr>
              <th className={s.th}>Simplified</th>
              <th className={s.th}>Traditional</th>
              <th className={s.th}>Pinyin</th>
              <th className={s.th}>Definition</th>
              <th className={s.th}>Radical</th>
              <th className={s.th}>Strokes</th>
              <th className={s.th}>HSK</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} className={s.td}>Loading...</td></tr>
            ) : data.characters.length === 0 ? (
              <tr><td colSpan={7} className={s.td}>No characters found</td></tr>
            ) : (
              data.characters.map((char) => (
                <tr key={char.id}>
                  <td className={`${s.td} ${s.tdCharSimplified}`}>
                    {char.simplified_char}
                  </td>
                  <td className={`${s.td} ${s.tdCharTraditional}`}>
                    {char.traditional_char || '-'}
                  </td>
                  <td className={s.td}>{char.pinyin}</td>
                  <td className={s.td}>{char.definition_en}</td>
                  <td className={`${s.td} ${s.tdCharRadical}`}>{char.radical || '-'}</td>
                  <td className={s.td}>{char.stroke_count || '-'}</td>
                  <td className={s.td}>
                    <span className={s.hskBadge}>HSK {char.hsk_level}</span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {pagination.pages > 1 && (
        <div className={s.paginationRow}>
          <button
            disabled={page <= 1}
            onClick={() => setPage(page - 1)}
            className={s.pageBtn}
          >
            Prev
          </button>
          <span className={s.pageInfo}>
            Page {pagination.page} of {pagination.pages} ({pagination.total} total)
          </span>
          <button
            disabled={page >= pagination.pages}
            onClick={() => setPage(page + 1)}
            className={s.pageBtn}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
